import { render } from "./ImageInfo.vue?vue&type=template&id=3636e203&scoped=true"
import script from "./ImageInfo.vue?vue&type=script&lang=ts"
export * from "./ImageInfo.vue?vue&type=script&lang=ts"

import "./ImageInfo.vue?vue&type=style&index=0&id=3636e203&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3636e203"

export default script